export default __webpack_public_path__ + "c3b5cf67cb0c07a63b8658aa76312ec4.mp3";